import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import type { CampaignMetrics } from "../types";

async function getCampaignMetrics(
  workspaceId: string,
  campaignId: string,
): Promise<CampaignMetrics> {
  return (
    await get(`workspaces/${workspaceId}/campaigns/${campaignId}/metrics`)
  ).metrics;
}

export default function useCampaignMetrics(campaignId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: campaignMetrics, isLoading: isLoadingCampaignMetrics } =
    useQuery({
      queryKey: campaignsKeys.metrics(campaignId),
      queryFn: () => getCampaignMetrics(workspaceId, campaignId),
    });

  return { campaignMetrics, isLoadingCampaignMetrics };
}
